module.exports = Object.freeze({
  IdentityGreen: "#3E937D",
  IdentityPink: "#EEB2D9",
  DarkBackground: "#10192F"
});